import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
interface HeroSectionProps {
  isDark: boolean;
}
export function HeroSection({
  isDark
}: HeroSectionProps) {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-[#f8f9fb] dark:bg-[#0f1629] transition-colors duration-300" data-id="element-233">
      {/* Background Effects */}
      <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-accent-500/8 dark:bg-accent-500/15 rounded-full blur-[140px] -z-10" data-id="element-234"></div>
      <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-primary-500/8 dark:bg-primary-500/15 rounded-full blur-[140px] -z-10" data-id="element-235"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-236">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none backdrop-blur-sm mb-8" data-id="element-237">
          <span className="flex h-2 w-2 rounded-full bg-primary-500 animate-pulse" data-id="element-238"></span>
          <span className="text-sm font-medium text-slate-600 dark:text-slate-300" data-id="element-239">
            Mortgage Broker
          </span>
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-slate-900 dark:text-white mb-6 leading-[1.1]" data-id="element-240">
          Smarter Property <br className="hidden md:block" data-id="element-241" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent-500 to-primary-500" data-id="element-242">
            Starts Here!
          </span>
        </h1>

        {/* Subheadline */}
        <p className="mt-4 text-xl md:text-2xl text-slate-600 dark:text-slate-400 max-w-3xl mx-auto mb-12 leading-relaxed font-light" data-id="element-243">
          Whether you're buying your first home or your next investment, we help
          you structure it properly from the start.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-244">
          <Link to="/#contact" className="w-full sm:w-auto px-8 py-4 rounded-xl bg-gradient-to-r from-accent-500 to-primary-500 text-white font-semibold text-lg hover:shadow-[0_0_30px_rgba(20,184,166,0.35)] transition-all flex items-center justify-center gap-2 group hover:scale-[1.02]" data-id="element-245">
            Start Your Strategy
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-246" />
          </Link>
          <Link to="/tools" className="w-full sm:w-auto px-8 py-4 rounded-xl bg-white dark:bg-white/5 hover:bg-slate-50 dark:hover:bg-white/10 border border-slate-200 dark:border-white/10 text-slate-900 dark:text-white font-semibold text-lg shadow-sm dark:shadow-none transition-all flex items-center justify-center gap-2" data-id="element-247">
            See Your Position
          </Link>
        </div>
      </div>
    </section>;
}